import { useEffect, type ReactNode } from "react";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/Button";

export function RequireAuth({ children }: { children: ReactNode }) {
  const auth = useAuth();

  useEffect(() => {
    if (auth.status === "unauthenticated") {
      void auth.signIn(window.location.pathname + window.location.search);
    }
  }, [auth]);

  if (auth.status === "forbidden") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 px-6">
        <div className="max-w-md rounded-lg border border-red-200 bg-white p-6 text-center shadow-sm">
          <p className="text-sm font-medium text-slate-900">Acceso restringido</p>
          <p className="mt-2 text-sm text-slate-600">
            Esta consola es solo para administradores. El número{" "}
            <span className="font-mono">{auth.user.phone}</span> no tiene rol admin.
          </p>
          <Button variant="ghost" size="sm" className="mt-4" onClick={() => auth.signOut()}>
            Cerrar sesión
          </Button>
        </div>
      </div>
    );
  }

  if (auth.status !== "authenticated") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <Loader2 className="h-8 w-8 animate-spin text-brand-600" />
      </div>
    );
  }

  return <>{children}</>;
}
